import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useRef,
  createRef,
  useEffect,
} from "react";

const FichaCoopPreguntasConversion = forwardRef((props, ref) => {
  const [preguntasSeleccionadas, setPreguntasSeleccionadas] = useState([]);

  const handleChange = (e) => {
    const { value, checked } = e.target;
    const newSelectedPreguntas = toggleIds(
      preguntasSeleccionadas,
      value,
      checked
    );
    props.onChange(newSelectedPreguntas);
    setPreguntasSeleccionadas(newSelectedPreguntas);
  }

  const toggleIds = (array, id, checked) => {
    if (checked) {
      return [...array, id];
    } else {
      return array.filter((item) => item !== id);
    }
  }



  return (
    <div className="m-b-15">

      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            <th>Variable</th>
            <th>Conversion</th>
            <th>Si / No</th>
          </tr>
        </thead>
        <tbody>
          {props?.fichaMaster?.conversiones?.map((item, index) => (
            <tr key={index}>
              <td>{item.label}</td>
              <td>{item.unidad_conversion}</td>
              <td>
                <input
                  id={"config_id_pregunta_" + item.config_id_pregunta}
                  value={item.config_id_pregunta}
                  name={"config_id_pregunta_" + item.config_id_pregunta}
                  type="checkbox"
                  checked={preguntasSeleccionadas.includes(
                    item.config_id_pregunta
                  )}
                  onChange={handleChange}
                  
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
});

export default FichaCoopPreguntasConversion;
